import { useMutation, useQueryClient } from '@tanstack/react-query';
import { patchDmNotes } from '../services/dmNotes';
import { storeSavedDmNotes } from './dmNotesCache';

export interface SaveDmNotesVariables {
    patientId: string;
    text: string;
}

export interface SavedDmNotes {
    patientId: string;
    notes: string;
}

// The patient travels with the variables so a save that lands after a switch updates its own patient.
export function useSaveDmNotes() {
    const queryClient = useQueryClient();
    return useMutation<SavedDmNotes, Error, SaveDmNotesVariables>({
        mutationFn: async ({ patientId, text }) => {
            const data = await patchDmNotes(patientId, text);
            return { patientId, notes: data.notes ?? '' };
        },
        onSuccess: ({ patientId, notes }) => storeSavedDmNotes(queryClient, patientId, notes)
    });
}
